<template lang="pug">
div
  Form(:data="behaviour", :isSubmitting="isSubmitting", :readOnly="isReadOnly", @submit="(data, imgFile, deleteImage) => update(data, imgFile, deleteImage)")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useBehaviourEdit from './useBehaviourEdit'

export default {
  components: {
    Form,
  },
  setup() {
    const { show, update, behaviour, isSubmitting, isReadOnly } = useBehaviourEdit()

    onMounted(show)

    return {
      behaviour,
      update,
      isSubmitting,
      isReadOnly,
    }
  },
}
</script>
